import { useRef, useEffect } from 'react';
import { Animated } from 'react-native';

/**
 * Custom hook for spinning animation
 * @param isLoading - Whether the animation should be active
 * @param duration - Animation duration in milliseconds (default: 1000)
 * @returns Animated spin value for transform rotation
 */
export const useSpinAnimation = (isLoading: boolean, duration: number = 1000) => {
  const spinValue = useRef(new Animated.Value(0)).current;

  // Spin animation effect
  useEffect(() => {
    let spinAnimation: Animated.CompositeAnimation;
    
    if (isLoading) {
      spinAnimation = Animated.loop(
        Animated.timing(spinValue, {
          toValue: 1,
          duration,
          useNativeDriver: true,
        })
      );
      spinAnimation.start();
    } else {
      spinValue.setValue(0);
    }

    return () => {
      if (spinAnimation) {
        spinAnimation.stop();
      }
    };
  }, [isLoading, spinValue, duration]);

  // Create spin interpolation
  const spin = spinValue.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '360deg'],
  });

  return spin;
};
